// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let RelayEnv = require("../../../../RelayEnv.bs.js");
let ReasonPromise = require("../../../../reason/ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Utils__Promise = require("../../../../utils/Utils__Promise.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let GeocodingQuery_graphql = require("../../../../__generated__/GeocodingQuery_graphql.bs.js");

let convertVariables = GeocodingQuery_graphql.Internal.convertVariables;

let convertResponse = GeocodingQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = GeocodingQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, GeocodingQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, GeocodingQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(GeocodingQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(GeocodingQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(GeocodingQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(GeocodingQuery_graphql.node, convertVariables);

let Query_geocodingErrorReason_decode = GeocodingQuery_graphql.Utils.geocodingErrorReason_decode;

let Query_geocodingErrorReason_fromString = GeocodingQuery_graphql.Utils.geocodingErrorReason_fromString;

let Query_propertyOwnerClientType_decode = GeocodingQuery_graphql.Utils.propertyOwnerClientType_decode;

let Query_propertyOwnerClientType_fromString = GeocodingQuery_graphql.Utils.propertyOwnerClientType_fromString;

let Query = {
  geocodingErrorReason_decode: Query_geocodingErrorReason_decode,
  geocodingErrorReason_fromString: Query_geocodingErrorReason_fromString,
  propertyOwnerClientType_decode: Query_propertyOwnerClientType_decode,
  propertyOwnerClientType_fromString: Query_propertyOwnerClientType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function queryFn(address, areaId, clientType, existingPropertyId) {
  return ReasonPromise.map(Utils__Promise.fromJsPromise(fetchPromised(RelayEnv.environment, {
    input: {
      address: address,
      areaId: areaId,
      clientType: clientType,
      existingPropertyId: existingPropertyId
    }
  }, undefined, undefined)), v => {
    if (v.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: {
          NAME: "REJECTED",
          VAL: v._0
        }
      };
    }
    let response = v._0.validatePropertyAddress;
    if (response === undefined) {
      return {
        TAG: "Error",
        _0: "EMPTY_RESPONSE"
      };
    }
    switch (response.__typename) {
      case "PropertyAddressValidated" :
        let standardizedAddress = response.standardizedAddress;
        let coordinates = response.coordinates;
        let tmp;
        if (standardizedAddress !== undefined) {
          let address = standardizedAddress.address;
          if (address !== undefined) {
            let city = standardizedAddress.city;
            if (city !== undefined) {
              let state = standardizedAddress.state;
              if (state !== undefined) {
                let zip = standardizedAddress.zip;
                tmp = zip !== undefined ? ({
                    address: address,
                    zip: zip,
                    city: city,
                    state: state
                  }) : undefined;
              } else {
                tmp = undefined;
              }
            } else {
              tmp = undefined;
            }
          } else {
            tmp = undefined;
          }
        } else {
          tmp = undefined;
        }
        return {
          TAG: "Ok",
          _0: {
            NAME: "PropertyAddressValidated",
            VAL: {
              displayNeighborhoods: Stdlib_Option.getOr(response.displayNeighborhoods, []).map(dn => ({
                __typename: dn.__typename,
                __id: dn.__id,
                id: dn.id,
                label: dn.label
              })),
              coordinates: coordinates !== undefined ? ({
                  lat: coordinates.lat,
                  lon: coordinates.lon
                }) : undefined,
              standardizedAddress: tmp
            }
          }
        };
      case "ValidatePropertyAddressDuplicatePropertyError" :
        return {
          TAG: "Ok",
          _0: {
            NAME: "DuplicatePropertyError",
            VAL: response.property
          }
        };
      case "ValidatePropertyAddressGeocodingError" :
        let tmp$1 = response.reason;
        if (tmp$1 === "OUTSIDE_CHAPTER_BOUNDARIES") {
          return {
            TAG: "Ok",
            _0: {
              NAME: "GeocodingError",
              VAL: "OutsideChapterBoundaries"
            }
          };
        } else {
          return {
            TAG: "Ok",
            _0: {
              NAME: "GeocodingError",
              VAL: "UnableToGeocode"
            }
          };
        }
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "UNSELECTED_MEMBER"
        };
    }
  });
}

exports.Query = Query;
exports.queryFn = queryFn;
/* use Not a pure module */
